import { DataView24 } from "@carbon/icons-react";
import {
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
} from "carbon-components-react";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "../../components/Card/Card";
import TablePagination from "../../components/Pagination/Pagination";
import { AuthContext } from "../../contexts/AuthContext";
import http from "../../http-common";

const tableHeaders = [
  // {
  //   header: "NUR",
  //   key: "nur",
  // },
  {
    header: "# Plano de Negócio",
    key: "order",
  },
  {
    header: "Total",
    key: "totalScore",
  },
  {
    header: "Conversão",
    key: "conversion",
  },
  {
    header: "Consultar",
    key: "actions",
  },
];

const LinkList = ({ url }) => (
  <ul style={{ display: "flex" }}>
    <li>
      <Link to={url} title="Consultar">
        <DataView24 />
      </Link>
    </li>
  </ul>
);

const getCellContent = (cell, id) => {
  if (cell.info.header === "totalScore") {
    return cell.value != null ? parseFloat(cell.value).toFixed(2) : "";
  }
  if (cell.info.header === "conversion") {
    return cell.value != null ? parseFloat(cell.value).toFixed(2) + "%" : "";
  }
  if (cell.info.header === "actions") {
    return <LinkList url={"../plano-de-negocio-juri/" + id} />;
  }
  return cell.value;
};

const BusinessPlanEvaluationPage = () => {
  const { user, isJury } = useContext(AuthContext);
  const [businessPlans, setBusinessPlans] = useState([]);
  const [apps, setApps] = useState([]);
  const [count, setCount] = useState(0);
  const [size, setSize] = useState(20);

  const navigate = useNavigate();

  const getJuryBusinessPlans = async () => {
    try {
      const response = await http.get(
        `/business-plan/jury-business-plans?username=${user.username}`
      );
      setBusinessPlans(response.data);
    } catch (error) {}
  };

  const onPageChange = async ({ page, pageSize }) => {
    try {
      var pag = page - 1;
      const response = await http.get(
        `/applications/jury-applications/filter?username=${user.username}&page=${pag}&size=${pageSize}`
      );
      setApps(response.data.content);
      setCount(response.data.totalElements);
    } catch (error) {}
  };

  const search = async (phoneNumber1) => {
    try {
      const response = await http.get(
        "/applications/search/filter?competitor.phoneNumber1=" + phoneNumber1
      );
      setApps(response.data.content);
      // getApplicationData(response);
    } catch (error) {}
  };

  const getApplicationData = (response) => {
    const data = response.data.content.map((item) => ({
      id: item.application.uuid,
      // nur: "NUR" + item.application.competitor.phoneNumber1,
      hasBusinessCurrently: item.application.hasBusinessCurrently
        ? "Sim"
        : "Não",
      currentStageDesc: item.application.currentStage.description,
      currentEligibilityStatusDesc:
        item.application.currentEligibilityStatus.description,
    }));
    setApps(data);
    setCount(response.data.totalElements);
  };

  useEffect(() => {
    getJuryBusinessPlans();
  }, []);

  return (
    <Card title="Avaliação de Planos de Negócio">
      <DataTable
        rows={businessPlans}
        headers={tableHeaders}
        isSortable
        useZebraStyles
      >
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {getCellContent(cell, row.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
    </Card>
  );
};

export default BusinessPlanEvaluationPage;
